interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  textColor?: string;
}

export default function Logo({ className = '', size = 'md', showText = true, textColor = 'text-slate-900' }: LogoProps) {
  const sizes = {
    sm: { container: 'w-8 h-8', icon: 'text-base', text: 'text-lg' },
    md: { container: 'w-11 h-11', icon: 'text-xl', text: 'text-2xl' },
    lg: { container: 'w-16 h-16', icon: 'text-3xl', text: 'text-4xl' }
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        {/* Main gradient background */}
        <div className={`${currentSize.container} bg-gradient-to-br from-teal-500 via-emerald-500 to-teal-600 rounded-2xl shadow-lg relative overflow-hidden`}>
          {/* Animated shine effect */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/20 to-transparent"></div>
          
          {/* Camera icon */}
          <div className="absolute inset-0 flex items-center justify-center">
            <i className={`ri-camera-line text-white ${currentSize.icon}`}></i>
          </div>
          
          {/* AI Sparkle badge */}
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-br from-amber-400 via-orange-500 to-pink-500 rounded-full flex items-center justify-center shadow-md">
            <i className="ri-sparkling-fill text-white text-xs"></i>
          </div>
          
          {/* Neural network dots */}
          <div className="absolute top-1 left-1 w-1.5 h-1.5 bg-white/40 rounded-full"></div>
          <div className="absolute bottom-1 left-2 w-1 h-1 bg-white/30 rounded-full"></div>
          <div className="absolute top-2 right-1 w-1 h-1 bg-white/30 rounded-full"></div>
        </div>
      </div>
      
      {showText && (
        <span className={`${currentSize.text} font-bold ${textColor} tracking-tight`}>
          Learn<span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-emerald-500">snap</span>
        </span>
      )}
    </div>
  );
}
